module.exports = __webpack_public_path__ + "img/input.cd9a78ef.svg";